import React from 'react'
import { CaptionText, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import * as styles from './activity.css'
import { useLocalizedContent } from '../../../../../hooks/useLocalizedContent'
import type { ActivityInformation, Edge } from '../../../../../../../typings'
import { getActivityItems, type PersonInfo } from '../../../utils/activityItem'
import ActivityItemTemplate from '../../../components/ActivityItemTemplate'

const renderActivityPerson = (personInfo: PersonInfo) => {
  return (
    <BodyText type="strong">
      {personInfo.name ? (
        personInfo?.name?.fullName
      ) : (
        <Message id="activity.anonymous" />
      )}
    </BodyText>
  )
}

const renderDescription = (itemDescription: string) => {
  return (
    <div
      className={styles.activityDescriptionStyles}
      data-testid="descriptionActivity"
    >
      <BodyText as="p">{itemDescription}</BodyText>
    </div>
  )
}

const renderContributorAmount = (
  amount: string,
  amountContributedLabel: string,
) => {
  return (
    <BodyText as="p" className={styles.contributorAmount}>
      {/* This is necessary to use blue color in amount */}
      <span
        className={styles.colorAmountPositiveStyle}
        aria-label={amountContributedLabel}
      >
        {amount}
      </span>
    </BodyText>
  )
}

const renderActivityTime = (timeInfo: string) => {
  return <CaptionText>{timeInfo}</CaptionText>
}

export const ActivityItems = ({
  isAdmin,
  activities,
  onActivityLinkClick,
}: {
  isAdmin: boolean
  activities: Edge<ActivityInformation>[]
  onActivityLinkClick?: () => void
}) => {
  const { getContent } = useLocalizedContent()

  return (
    <>
      {getActivityItems(activities).map((item) => (
        <ActivityItemTemplate
          isAdmin={isAdmin}
          key={item.transactionId}
          item={item}
          contributorAmount={renderContributorAmount(
            item.amount,
            getContent('detail.amountContributed', {
              amount: item.amount,
            }),
          )}
          renderActivityPerson={renderActivityPerson}
          renderActivityTime={renderActivityTime}
          renderDescription={renderDescription}
          onActivityLinkClick={onActivityLinkClick}
          styles={styles}
        />
      ))}
    </>
  )
}
